<div class="slider__trending">
  <app-tags classes="tags_trending" [tags$]="requests$" />
</div>
